import ImpactsOnStakeholderOverview from './ImpactsOnStakeholderOverview';

export default ImpactsOnStakeholderOverview;
